/**
 * 加载类型
 */ 
export interface LoadingType {
  /** 外层加载 */
  showA: boolean;
  /** 弹窗加载 */
  showB: boolean;
  /** 加载文案 */
  text: string;
  /** 加载倒计时 */
  second: number;
}

/**注册的入参接口 */
export interface  RegisterParamsType {
  [x:string]: string;
  /**账号类型 1，邮箱 2，手机 */
  type: string;
}

/**加入公司列表接口 */
export interface CompanyListType {
  [x:string]: string;
  auditingFlag: string;
  auditingModel: string;
  companyId: string;
  companyType: string;
  name: string;
  statusFlag: string;
}

export interface CommonState {
  /** 加载  */
  readonly loading: LoadingType;
  readonly projectSetting:any;
}

export enum CommonActionTypes {
  /** 加载 */
  FETCH_LOADING = "页面加载/FETCH_LOADING",
  /** 更新公共状态 */
  FETCH_UPDATE_COMMON_STATE = "更新公共状态/FETCH_UPDATE_COMMON_STATE",
  FETCH_GET_PROJECT_SETTING = "获取项目配置/FETCH_GET_PROJECT_SETTING",
}